import { clearUserBootstrapCache, useUserBootstrap } from "./useUserBootstrap";

export const clearSubscriptionCache = clearUserBootstrapCache;

export const useSubscriptionStatus = () => {
  const {
    subscriptionStatus,
    cancelAtPeriodEnd,
    pastDueSince,
    loading,
    error,
    retry,
  } = useUserBootstrap();

  return {
    subscriptionStatus,
    cancelAtPeriodEnd,
    pastDueSince,
    loading,
    error,
    retry,
  };
};
